import module from '../module';
import Constants from '../../../utils/CommonConstants';
import { communicationService } from "./../../../services/communicationService";
import {commandKeys} from "../../../shared/commandKeys";

class ConfirmTicketController {
    static $inject = [ '$scope', '$stateParams', 'AuthenticationService', '$state','Message','SessionStorage','$rootScope' ];

    constructor($scope, $stateParams, authenticationService, $state,messageService,sessionStorageService,$rootScope) {
        this._messageService = messageService;
        $scope.validated = false;
        $scope.success = true;
        $scope.inProgress = false;
        $scope.password = '';
        $scope.confirmPassword = '';
        $scope.errorMessage = '';
        this._rootScope = $rootScope;
        this._scope = $scope;
        this._sessionStorageService = sessionStorageService;
        $scope.continue = async () => {
            this._sessionStorageService.clear(Constants.SessionStorage.LAST_STATE_NAME);
            $state.go(Constants.RoutingStates.CART);
        };

        $scope.sendRequest = (form) => {
            if (!form.$valid) {
                form.highlightAllErrors();
                return;
            }

            $scope.inProgress = true;
            $scope.errorMessage = '';

            authenticationService.validatePasswordTicket($stateParams.ticket, $scope.password)
                                 .then((response) => {
                                     $scope.inProgress = false;
                                     $scope.success = response.success;
                                     $scope.validated = $scope.success;
                                     $scope.errorMessage = response.errorMessage;
                                     this._scope.$apply();
                                 }).then(() => {
                                        return  communicationService.requestToParent(commandKeys.removeHashKey, {});
                                 }).catch(async (error) => {
                                        $scope.inProgress = false;
                                        $scope.validated = false;
                                        $scope.success = false;
                                        this._messageService.showErrorPopupForResponse(error);
                                        this._scope.$apply();
                                        this._sessionStorageService.clear(Constants.SessionStorage.LAST_STATE_NAME);
                                        await communicationService.requestToParent(commandKeys.removeHashKey, {});
                                 });
        };
    }

    async $onInit() {
        this._rootScope.storeWindowTitle = 'client.user.reset_password';
        try {
            window.parent.postMessage({
                toggleWindowState: true,
                toggleWindowTrigger: 'titleBar'
            }, '*');

        } catch (error) {
            console.log(error);
        }
    }
}

module.controller('Cartonomy.Shared.ConfirmTicketController', ConfirmTicketController);




// WEBPACK FOOTER //
// ./src/modules/shared/controllers/ConfirmTicketController.js